import type { ShortcutAction } from '../shared/types';

/**
 * Genel kısayol kombinasyonları — tek kaynak.
 *
 * Ana süreç bunlarla `globalShortcut.register` yapıyor, Ayarlar ekranı da
 * etiketleri buradan (tercih verisiyle birlikte) alıyor; etiket ile gerçek
 * kayıt hiçbir zaman ayrışmıyor. Electron'a bağımlılığı yok: testlerden
 * doğrudan okunabiliyor.
 */
export const SHORTCUTS: Record<ShortcutAction, string> = {
  'toggle-recording': 'Control+Alt+Shift+R',
  'recording-notes': 'Control+Alt+Shift+N',
  'quick-find': 'Control+Alt+Shift+K',
};
